import {
  afterNextRender,
  computed,
  Directive,
  effect,
  Injector,
  TemplateRef,
  inject,
  input,
} from '@angular/core';
import { TableResizeUIService } from '../services/table-resize.service';
import { TableConstructUIService } from '../services/table-construct.service';

@Directive({ selector: '[fr8botUiTableHeaderRowDef]' })
export class TableHeaderRowDefUIDirective<DataType> {
  templateRef = inject<TemplateRef<DataType>>(TemplateRef);
  private tableService = inject<TableConstructUIService<DataType>>(TableConstructUIService);
  private resizeService = inject(TableResizeUIService);
  private injector = inject(Injector);

  readonly fr8botUiTableHeaderRowDef = input.required<string[]>();
  readonly fr8botUiTableHeaderRowDefRowName = input<string | null>(null);

  public rowName = this.fr8botUiTableHeaderRowDefRowName;
  public columns = computed(() => {
    const columns = this.fr8botUiTableHeaderRowDef();
    const rowName = this.rowName();
    return columns.map((column) => `${rowName ? rowName + '_' : ''}${column}`);
  });

  constructor() {
    effect(() => {
      const rowName = this.rowName();
      const aliasedColumns = this.columns();

      if (!rowName) {
        this.resizeService.setColumnsOrder(aliasedColumns);

        if (!!aliasedColumns.length) {
          // Column templates register through their own effects, which may run after this one
          // (e.g. when the table is embedded and the columns config is available synchronously).
          // Defer the validation until after render so all column defs have registered.
          afterNextRender(
            () => {
              const registeredColumnsTemplates = this.tableService.getRegisteredTemplateColumns();
              const unregisteredColumns = aliasedColumns.filter(
                (column) => !registeredColumnsTemplates.includes(column),
              );

              if (!!unregisteredColumns.length) {
                throw new Error(
                  `Provide templates for following columns: ${unregisteredColumns.join(', ')}`,
                );
              }
            },
            { injector: this.injector },
          );
        }
      }
    });
  }
}
